( function () {
	'use strict';

	function reorder ( $modal ) {
		function openReorderModal ( template, isSaving ) {
			$modal.open( {
				'templateUrl'      : '/templates/templates-new/reorder/reorder-modal.html',
				'controller'       : 'ReorderCtrl',
				'controllerAs'     : 'vm',
				'bindToController' : true,
				'resolve'          : {
					'templateModel' : function () {
						return template;
					},

					'isSaving' : function () {
						return isSaving;
					}
				}
			} );
		}

		return {
			'restrict' : 'A',
			'scope'    : {
				'template' : '=',
				'isSaving' : '='
			},

			'link' : function ( scope, element ) {
				element.on( 'click', function () {
					openReorderModal( scope.template, scope.isSaving );
				} );
			}
		};
	}

	angular
		.module( 'app.templates' )
		.directive( 'reorder', reorder );

	reorder.$inject = [ '$modal' ];
} )( );
